import { ITopBarBoardStateLocalStorage, TOP_BAR_BOARD_LOCALSTORAGE } from '../types';

export const getLastUsedFilter = (): ITopBarBoardStateLocalStorage => {
    const data = localStorage.getItem(TOP_BAR_BOARD_LOCALSTORAGE);
    const cardDescriptionUnsaved = data? JSON.parse(data): '';
    return cardDescriptionUnsaved;
};
